import axios from 'axios';

// search announcement api
export async function getAnnouncementAPI() {
	let announcement = [];
	// const percentage = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}system/announcement/getannouncement`,
			// data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		announcement = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return announcement;
}

//update vat percent api
export async function updateAnnouncementAPI(Data, userID) {
	let announcement = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}system/announcement/update`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		announcement = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return announcement;
}